import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA-D5vy_Mp-ASrrJAGPhupFjVLs6NCJEMk",
  authDomain: "walkup-music-app.firebaseapp.com",
  projectId: "walkup-music-app",
  storageBucket: "walkup-music-app.firebasestorage.app",
  messagingSenderId: "217269876523",
  appId: "1:217269876523:web:dc833b6504e77e3603376e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;